import React from 'react';
import i18n from 'i18next';

const Logo = () => {
  const lang = i18n.resolvedLanguage;
  return <img alt='IRTA' style={{height: '100%', marginRight: '30px'}} src={`images/Logo-IRTA_desc_horit-${lang}.png`}/>;
};

export default Logo;
